import { useState, useEffect } from 'react';
import { PERMISSIONS_UPDATED_EVENT } from '../constants/modules';

const permissionCache = {};

// Called by the admin's User Roles screen after a successful toggle/reset so
// every open usePermissions() consumer re-fetches instead of holding a stale
// cache until a full page reload.
export function invalidatePermissionCache() {
  Object.keys(permissionCache).forEach(k => delete permissionCache[k]);
  window.dispatchEvent(new CustomEvent(PERMISSIONS_UPDATED_EVENT));
}

export function usePermissions() {
  const user  = JSON.parse(localStorage.getItem('user') || '{}');
  const role  = user.role || 'staff';
  const token = localStorage.getItem('token');
  const [perms,   setPerms]   = useState(permissionCache[role] || {});
  const [loading, setLoading] = useState(!permissionCache[role]);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    const bump = () => setReloadKey(k => k + 1);
    window.addEventListener(PERMISSIONS_UPDATED_EVENT, bump);
    return () => window.removeEventListener(PERMISSIONS_UPDATED_EVENT, bump);
  }, []);

  useEffect(() => {
    if (permissionCache[role]) { setPerms(permissionCache[role]); setLoading(false); return; }
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/role-permissions/${role}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(d => {
        permissionCache[role] = d;
        setPerms(d);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [role, token, reloadKey]);

  // Admin always has full access
  const can = (module, action) => {
    if (role === 'admin') return true;
    return perms[module]?.[`can_${action}`] === true;
  };

  return { can, perms, loading, role };
}
